module.exports = __webpack_public_path__ + "img/img-badge-006-off@2x.30d547bb.png";